import { useState } from 'react';
import Styles from './styles.module.css';
import Logo from '../../../image/home/logo.png';
import { IoReorderThreeOutline, IoCloseOutline, IoDownloadOutline } from 'react-icons/io5';
import { DOC_DOWNLOAD_URL, CONSULT_URL, SCHOOL_LOGIN_URL, STUDENT_APP_URL } from '../_config';

/*
 * 学校向けの専用ヘッダー。サロン向け（home/1.navigation）とは
 * リンク先（ログイン = 学校管理画面）と CTA が異なるため別コンポーネントにしている。
 */
const NAV_LINKS = [
  { label: 'サービスについて', href: '#shift' },
  { label: '求人票が届くまで', href: '#flow' },
  { label: '導入の流れ', href: '#steps' },
  { label: 'よくある質問', href: '#faq' },
];

const SchoolNav = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className={Styles.nav}>
      <div className={Styles.inner}>
        <a href="/school" className={Styles.brand}>
          <img src={Logo} alt="memorii works" />
          <span className={Styles.brandNote}>美容・理容専門学校向け</span>
        </a>

        <nav className={Styles.links}>
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href}>{l.label}</a>
          ))}
          <a href={STUDENT_APP_URL} target="_blank" rel="noopener noreferrer">学生向け就活アプリ</a>
        </nav>

        <div className={Styles.actions}>
          <a href={SCHOOL_LOGIN_URL} className={Styles.login}>ログイン</a>
          <a href={DOC_DOWNLOAD_URL} className={Styles.cta}>
            <IoDownloadOutline />資料ダウンロード
          </a>
        </div>

        <button
          className={Styles.burger}
          aria-label="メニュー"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <IoCloseOutline /> : <IoReorderThreeOutline />}
        </button>
      </div>

      {open && (
        <div className={Styles.sheet}>
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)}>{l.label}</a>
          ))}
          <a href={STUDENT_APP_URL} target="_blank" rel="noopener noreferrer">学生向け就活アプリ</a>
          <a href={SCHOOL_LOGIN_URL}>ログイン</a>
          <a href={CONSULT_URL} className={Styles.sheetCta}>求人票管理について相談する</a>
          <a href={DOC_DOWNLOAD_URL} className={Styles.sheetCta}>資料をダウンロード</a>
        </div>
      )}
    </header>
  );
};

export default SchoolNav;
